<template>
  <div :class="`level-item-wrap ${active ? 'active' : ''}`" v-if="!short">
    <div class="level-item">
      <div class="level-item-image"><UserLevelImg :level="level" /></div>
      <div class="level-item-info">
        <div class="level-item-line">
          Баллы: <i>{{ n(points) }}</i>
        </div>
        <div class="level-item-line">
          Возврат: <i>{{ cashback }} %</i>
        </div>
        <div class="level-item-line">
          Бонус: <i>{{ bonus }}</i>
          <div class="level-item-q" @click="this.showTooltip = !this.showTooltip" v-if="wager > 0">
            ?
            <div class="level-item-q-p" v-if="this.showTooltip">
              Бонус предоставляется с вейджером х{{ wager }}. Вам нужно сделать х{{ wager }} ставок от суммы бонуса,
              чтобы отыграть бонус.
            </div>
          </div>
        </div>
        <div class="level-item-line">
          Лимит вывода: <i>{{ withdrawLimit }}</i>
        </div>
        <div class="level-item-line" v-if="hasFreespins">Бездепозитные FS: <i> ✓</i></div>
        <div class="level-item-line" v-if="personalManager">Личный менеджер: <i> ✓</i></div>
        <div class="level-item-line" v-if="premiumBonuses">Премиум бонусы: <i> ✓</i></div>
      </div>
    </div>
  </div>
  <div class="level-item-info-val" v-else>
    <div class="level-item-line">
      Баллы: <i>{{ n(points) }}</i>
    </div>
    <div class="level-item-line">
      Возврат: <i>{{ cashback }} %</i>
    </div>
    <div class="level-item-line">
      Бонус: <i>{{ bonus }}</i>
    </div>
    <div class="level-item-line">
      Лимит вывода: <i>{{ withdrawLimit }}</i>
    </div>
    <div class="level-item-line" v-if="hasFreespins">Бездепозитные FS: <i> ✓</i></div>
  </div>
</template>

<script>
import UserLevelImg from '@/components/UserLevelImg.vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
export default {
  name: 'LevelDescription',
  components: { UserLevelImg },
  props: {
    short: {
      type: Boolean,
      required: false,
    },
    level: {
      type: Number,
      required: true,
    },
    points: {
      type: Number,
      required: true,
    },
    cashback: {
      type: Number,
      required: true,
    },
    bonus: {
      type: String,
      required: true,
    },
    wager: {
      type: Number,
      required: false,
    },
    withdrawLimit: {
      type: String,
      required: true,
    },
    hasFreespins: {
      type: Boolean,
      required: false,
    },
    personalManager: {
      type: Boolean,
      required: false,
    },
    premiumBonuses: {
      type: Boolean,
      required: false,
    },
    active: {
      type: Boolean,
      required: false,
    },
  },
  setup() {
    const { t, n } = useI18n()
    const showTooltip = ref(false)
    return { t, n, showTooltip }
  },
}
</script>
